import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {isEmpty, maintenanceVaild} from "../../../components/commonmethod/CommonMethod";
import Th_title from "../../../components/Th_title";
import {SelectComboBoxForCreate} from "../../../components/select/SelectComboBoxForCreate";
import {saveInspection} from "../../../api/maintenance/InspectionService";
import {ButtonBasic} from "../../../components/buttons/ButtonBasic";
import {differenceInMonths, differenceInQuarters, differenceInWeeks, differenceInYears} from "date-fns";
import {useDispatch, useSelector} from "react-redux";
import {apiLoading} from "../../../redux/slice/apiSlice";
import {inspectionRequestCode, useSla} from "./InspectionCreate";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {CacheType, CodeSpecNum} from "../../../constant/CodeSpecNum";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import {SimmsRadio} from "../../../components/input/SimmsRadio";
import SimmsInput from "../../../components/input/SimmsInput";
import Selector from "../../../components/selector/Selector";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {useCacheRefresh} from "../../../hooks/useCacheRefresh";
import {
    ContentDetailThreeColLayout,
    DetailKvReadOnly,
    DetailKvTable,
    DetailFormPageShell,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";

export const inspectCycle = [
    {id: "매주(week)", name: "매주(week)"},
    {id: "매월(month)", name: "매월(month)"},
    {id: "분기(quarter)", name: "분기(quarter)"},
    {id: "반기(half)", name: "반기(half)"}
];

export const inspectionWeek = [
    {id: "1번째 주", name: "1번째 주"},
    {id: "2번째 주", name: "2번째 주"},
    {id: "3번째 주", name: "3번째 주"},
    {id: "4번째 주", name: "4번째 주"},
    {id: "5번째 주", name: "5번째 주"}
];

export const inspectionDay = [
    {id: "월요일", name: "월요일"},
    {id: "화요일", name: "화요일"},
    {id: "수요일", name: "수요일"},
    {id: "목요일", name: "목요일"},
    {id: "금요일", name: "금요일"},
    {id: "토요일", name: "토요일"},
    {id: "일요일", name: "일요일"}
];

export const assetSingleOrBulkUseCode = [
    {value: "single", text: "자산개별 점검등록"},
    {value: "bulk", text: "자산일괄 점검등록"},
];

function InspectionHeaderCreate() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const currentDate = new Date();
    const [inspection, setInspection] = useState({
        requestCode: 0, assetSingleOrBulkUse: "bulk", useSla: true, requester: user,
        periodicUse: true, inspector: user, periodDateLimit: 1
    });
    const [assets, setAssets] = useState([]);
    const [handler, setHandler] = useState([]);
    const refreshCache = useCacheRefresh();
    const location = useLocation();
    const navigate = useNavigate();
    const requireds = ["title", "requester", "inspectCode", "inspectStartDate", "inspectEndDate", "useSla", "inspector"];

    const create = async () => {
        if (assets.length === 0) {
            alert("자산을 선택해주세요");
            return false;
        }

        if (inspection.periodicUse && !inspection.inspectCycle) {
            alert("정기점검 주기를 선택해주세요");
            return;
        }

        if (inspection.inspectCycle && !inspection.periodRepeatCount) {
            alert("날짜계산을 눌러주세요");
            return;
        }

        if (!maintenanceVaild(handler, inspection, requireds)) return;

        if (requireds.some(e => isEmpty(inspection[e]))) {
            alert("필수값이 누락되었습니다.");
            return;
        }

        dispatch(apiLoading(true));

        const updatedData = {
            ...inspection,
            inspectCode: {id: inspection.inspectCode.id},
            inspector: {id: inspection.inspector.id},
            requester: {id: inspection.requester.id}
        };

        await saveInspection(updatedData, assets, handler, []).then(response => {
            if (response.status === 200) {
                alert("등록되었습니다.");
                refreshCache(CacheType.INSPECTION);
                const newId = response.data?.id;
                if (newId) {
                    navigate(`/maintenance/inspection_header/${newId}`, {state: {id: newId}});
                } else {
                    navigate("/maintenance/inspection_header", {state: {test: location.state}});
                }
            }
        }).finally(() => dispatch(apiLoading(false)));
    };

    function periodCalculation() {
        const assetLength = assets.length;
        if (assetLength === 0) {
            alert("자산을 선택해주세요");
            return;
        }

        if (inspection.periodicUse && inspection.inspectStartDate && inspection.inspectEndDate && inspection.inspectCycle) {
            if (inspection.inspectCycle !== "매주(week)" && !inspection.week) {
                alert("점검 주를 선택해주세요");
                return;
            }

            if ((inspection.inspectCycle === "매주(week)" || "분기(quarter)" || "반기(half)") && !inspection.day) {
                alert("점검 요일을 선택해주세요");
                return;
            }

            if (!inspection.periodDateLimit) {
                alert("정기점검 기한을 입력해주세요");
                return;
            } else if (!/^\d+$/.test(inspection.periodDateLimit)) {
                alert("정기점검 기한은 숫자만 입력해주세요");
                return;
            }

            const count = calculateInspections(inspection.inspectStartDate, inspection.inspectEndDate, inspection.inspectCycle);
            let msg = "";
            if (inspection.week) msg += " " + inspectionWeek.find(each => each.id == inspection.week).name;
            if (inspection.day) msg += " " + inspectionDay.find(each => each.id == inspection.day).name;

            alert(
                "점검시작일 : " + inspection.inspectStartDate.split("T")[0] + "\n" +
                "점검종료일 : " + inspection.inspectEndDate.split("T")[0] + "\n" +
                "점검설명 : " + inspectCycle.find(each => each.id == inspection.inspectCycle).name +
                msg + "  " +
                inspection.periodDateLimit + "일 이내 완료" +
                "\n" +
                "점검등록 진행 시 선택자산(" + assetLength + " 건)점검 항목(" + count + "건)을 새롭게 등록합니다. \n\n"
            );

            setInspection((prev) => ({
                ...prev,
                periodRepeatCount: count
            }));
        } else {
            alert("점검주기 혹은 점검기간을 지정해주세요");
        }
    }

    function calculateInspections(startDate, endDate, cycleId) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        let count = 1;

        switch (cycleId) {
            case "매주(week)":
                count = differenceInWeeks(end, start);
                break;
            case "매월(month)":
                count = differenceInMonths(end, start) + 1;
                break;
            case "분기(quarter)":
                count = differenceInQuarters(end, start);
                break;
            case "반기(half)":
                count = differenceInYears(end, start) * 2 + Math.floor(differenceInMonths(end, start) % 12 / 6);
                break;
            default:
                throw new Error("Invalid cycleId");
        }

        return count;
    }

    useEffect(() => {
        if (inspection && inspection.inspectCycle) {
            setInspection((prev) => {
                const updatedSearchObject = {...prev};
                delete updatedSearchObject["week"];
                delete updatedSearchObject["day"];
                delete updatedSearchObject["periodRepeatCount"];
                updatedSearchObject["periodDateLimit"] = 1;
                return updatedSearchObject;
            });
        }
    }, [inspection.inspectCycle]);

    useEffect(() => {
        if (inspection && inspection.inspectCode) {
            setInspection((prev) => {
                const updatedSearchObject = {...prev};
                delete updatedSearchObject["inspectCycle"];
                delete updatedSearchObject["week"];
                delete updatedSearchObject["day"];
                delete updatedSearchObject["periodRepeatCount"];
                updatedSearchObject["periodDateLimit"] = 1;
                return updatedSearchObject;
            });
        }
    }, [inspection.inspectCode, inspection.periodicUse]);

    const requestInfoPanel = (
        <DetailPanel title="점검요청정보">
            <DetailKvTable>
                <tbody>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="자산목록" colspan={3} className="fieldset-td relative align-top" required auth>
                        <UserSelectionField
                            layout="inline"
                            data={assets}
                            countUnit="개"
                            chipEntity="asset"
                            listModalTitle="자산목록"
                            onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                        >
                            <SearchSelector
                                auth
                                multiSelect
                                variant="compact"
                                entity="maintenance-assets"
                                uniqueKey="assets"
                                data={assets}
                                onChange={(v) => {
                                    if (v?.__multiFlat) setAssets(v.__multiFlat);
                                }}
                            >
                                <SimmsInputSearch type="TEXT"/>
                                <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive/>
                                <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive/>
                                <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive/>
                                <SimmsDrawerSearch showLabel title="SLA 그룹" entity="code" target="slaGroup" parentKey={CodeSpecNum.SlaGroupCode} uniqueKey="slaGroup" recursive/>
                                <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator"/>
                                <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler"/>
                            </SearchSelector>
                        </UserSelectionField>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="구분" colspan={3} className="fieldset-td" auth>
                        <SimmsRadio
                            options={assetSingleOrBulkUseCode}
                            onChange={(v) => inputOnChange(setInspection, "assetSingleOrBulkUse", v, true)}
                            data={inspection.assetSingleOrBulkUse}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <DetailKvReadOnly label="등록일시" value={currentDate.toISOString()} type="date"/>
                    <DetailKvReadOnly label="등록자" value={user.name}/>
                </tr>
                <tr>
                    <DetailKvReadOnly label="수정일시" value=""/>
                    <DetailKvReadOnly label="수정자" value=""/>
                </tr>
                <tr>
                    <Th_title title="점검 제목" colspan={3} className="fieldset-td" required auth>
                        <SimmsInput onChange={(v) => inputOnChange(setInspection, "title", v, true)} data={inspection?.title}/>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="요청자" colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setInspection, "requester", inspection.requester, v)}
                            data={inspection.requester}
                            entity="userAccount"
                            uniqueKey="requester"
                        >
                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                        </Selector>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="점검코드" colspan={1} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setInspection, "inspectCode", inspection.inspectCode, v)}
                            data={inspection.inspectCode}
                            entity="code"
                            parentKey={CodeSpecNum.InspectionRequestCode}
                            recursive
                        />
                    </Th_title>
                    <Th_title title="요청방식" colspan={1} className="fieldset-td" auth>
                        <SelectComboBoxForCreate
                            target="requestCode"
                            options={inspectionRequestCode}
                            data={{data: inspection, fnc: setInspection}}
                            defaultValue={inspection.requestCode}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="점검기간" colspan={3} className="fieldset-td fieldset-td-input" required>
                        <div className="web-flex asset-detail-date-range">
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setInspection, "inspectStartDate", v, true)}
                                data={inspection.inspectStartDate}
                                constraint={{lessThan: inspection.inspectEndDate && dayjs(inspection.inspectEndDate), required: true}}
                                auth
                            />
                            <span className="asset-detail-date-range-sep">~</span>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setInspection, "inspectEndDate", v, true)}
                                data={inspection.inspectEndDate}
                                constraint={{largerThan: inspection.inspectStartDate && dayjs(inspection.inspectStartDate), required: true}}
                                auth
                            />
                        </div>
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="정기점검 주기" colspan={3} className="fieldset-td fieldset-td-input" auth>
                        <div className="detail-kv-field-stack web-flex flex-wrap items-center gap-2">
                            <SelectComboBoxForCreate
                                target="inspectCycle"
                                options={inspectCycle}
                                data={{data: inspection, fnc: setInspection}}
                                defaultValue={inspection.inspectCycle}
                            />
                            {inspection.inspectCycle ? (
                                <>
                                    {inspection.inspectCycle !== "매주(week)" ? (
                                        <SelectComboBoxForCreate
                                            target="week"
                                            options={inspectionWeek}
                                            data={{data: inspection, fnc: setInspection}}
                                            defaultValue={inspection.week}
                                        />
                                    ) : null}
                                    {inspection.inspectCycle === "매주(week)" || "분기(quarter)" || "반기(half)" ? (
                                        <SelectComboBoxForCreate
                                            target="day"
                                            options={inspectionDay}
                                            data={{data: inspection, fnc: setInspection}}
                                            defaultValue={inspection.day}
                                        />
                                    ) : null}
                                </>
                            ) : null}
                            <ButtonBasic
                                text="날짜계산"
                                className="bg-[#1c90fb] text-[white] py-1 my-1"
                                variant="primary"
                                size="none"
                                onClick={periodCalculation}
                            />
                        </div>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="정기점검 기한(점검별)" colspan={3} className="fieldset-td fieldset-td-input" required auth>
                        <SimmsInput onChange={(v) => inputOnChange(setInspection, "periodDateLimit", v, true)} data={inspection?.periodDateLimit}/>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="SLA 사용여부" className="fieldset-td" colspan={3} required auth>
                        <SimmsRadio
                            options={useSla}
                            onChange={(v) => inputOnChange(setInspection, "useSla", v, true)}
                            data={inspection.useSla}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="비고" colspan={3} className="fieldset-td" auth>
                        <SimmsTextArea onChange={(v) => inputOnChange(setInspection, "etc", v, false)} data={inspection.etc} style={{width: "100%", minHeight: "80px"}}/>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const statusPanel = (
        <DetailPanel title="점검 요청 진행상태">
            <DetailKvTable>
                <tbody>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="담당자" colspan={3} className="fieldset-td fieldset-td-input relative align-top" required auth>
                        <UserSelectionField
                            layout="inline"
                            data={handler}
                            onRemove={(v) => setHandler((prev) => prev.filter((h) => h.id !== v.id))}
                        >
                            <SearchSelector
                                auth
                                multiSelect
                                variant="compact"
                                entity="userAccount"
                                uniqueKey="handler"
                                data={handler}
                                onChange={(v) => {
                                    if (v?.__multiFlat) setHandler(v.__multiFlat);
                                }}
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                            </SearchSelector>
                        </UserSelectionField>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="검수자" colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setInspection, "inspector", inspection.inspector, v)}
                            data={inspection.inspector}
                            entity="userAccount"
                            uniqueKey="inspector"
                        >
                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                        </Selector>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="정기점검 등록"
            meta="신규 정기점검 계획을 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/maintenance/inspection_header")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailThreeColLayout primary={requestInfoPanel} secondary={statusPanel}/>
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {InspectionHeaderCreate};
